/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_EyebrowInputs */

const cs_builder_block_eyebrow = /** @type {(inputs: Builder_Block_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horní štítek`)
};

const en_builder_block_eyebrow = /** @type {(inputs: Builder_Block_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eyebrow label`)
};

/**
* | output |
* | --- |
* | "Eyebrow label" |
*
* @param {Builder_Block_EyebrowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_eyebrow = /** @type {((inputs?: Builder_Block_EyebrowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_EyebrowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_eyebrow(inputs)
	return cs_builder_block_eyebrow(inputs)
});